import { ClassroomRoutes } from "./classroom-routes";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import {
	ClassroomComponent,
	ClassroomHomeComponent,
	ClassroomClassroomAttendanceComponent,
	ClassroomAttendanceIncidentComponent,
	ClassroomAttendancePointComponent,
	ClassroomAttendancePointAddPointsComponent,
	ClassroomAttendancePointRedeemPointsComponent,
	ClassroomAttendancePointVoidTransactionComponent,
	ClassroomAttendanceOtherComponent,
} from "./index";

import { FormsModule } from "@angular/forms";
import { AppSharedModule } from "../../shared/app-shared.module";
import { RouterModule } from "@angular/router";
import { CalendarModule } from "primeng/calendar";
import { HomeService } from "./home/home.service";
import { IncidentService } from "./classroomAttendance/incident/incident.service";
import { ClassroomAttendanceService } from "./classroomAttendance/classroomAttendance.service";
import { OtherService } from "./classroomAttendance/other/other.service";
import { GroupAddPointsComponent } from "./classroomAttendance/point/group-add-points/group-add-points.component";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DialogModule } from "primeng/dialog";

@NgModule({
	declarations: [
		ClassroomComponent,
		ClassroomHomeComponent,
		ClassroomClassroomAttendanceComponent,
		ClassroomAttendanceIncidentComponent,
		ClassroomAttendancePointComponent,
		ClassroomAttendanceOtherComponent,
		ClassroomAttendancePointAddPointsComponent,
		ClassroomAttendancePointRedeemPointsComponent,
		ClassroomAttendancePointVoidTransactionComponent,
		GroupAddPointsComponent,
	],
	imports: [CommonModule, FormsModule, AppSharedModule, CalendarModule, RouterModule, ConfirmDialogModule, DialogModule],
	providers: [HomeService, IncidentService, ClassroomAttendanceService, OtherService],
})
export class ClassroomModule {}
